import { Button } from "@oc-labs/wt-storybook";
import useModal from "../../hooks/useModal";
import ModalV2 from "../ModalV2";

export default function DeleteModal() {
  const { modal, close } = useModal("delete-modal");
  const data = modal?.props || {};

  return (
    <ModalV2 name="delete-modal">
      <div className="w-full max-w-sm bg-white rounded-2xl p-6 text-center">
        {data?.title && (
          <h2 className="text-xl font-semibold text-gray-900 mb-2">{data?.title}</h2>
        )}
        <p className="text-gray-600 mb-4">
          {data?.text || "Are you sure you want to delete this item?"}
        </p>

        <div className="mt-4 flex gap-2">
          <Button type="tertiary" onClick={close} className="secondary">
            Cancel
          </Button>

          <Button
            type="danger"
            onClick={async () => {
              if (data?.onDelete) await data.onDelete();
              close();
            }}
            className="danger"
          >
            Delete
          </Button>
        </div>
      </div>
    </ModalV2>
  );
}
